import Utils from './../../utils/Utils';
import storage from '../../components/DeviceStorage/DeviceStorage';
import Device from '../../devices/device';
import * as AnalyticsRESTClient from './AnalyticsRESTClient';
import logger from 'src/utils/logger/logger';
import getAppConfig from '../../config/appConfig';
import store from '../../store';
declare global {
  interface Window {
    newrelic: any;
  }
}


class NewRelic {

  private _newrelic: any;

  constructor() {
    this._newrelic = window && window.newrelic ? window.newrelic : {};
  }

  recordCustomEvent(eventType: string, attributes: object) {
    try {
      this.addPageAction(eventType, attributes);
      logger.debug(`NewRelic event ${eventType} sent`, attributes);
    } catch (error) {
      logger.error(`NewRelic event ${eventType} error`, error);
    }
  }

  addPageAction(eventName: string, information: object) {
    if (Utils.isFunction(this._newrelic.addPageAction)) {
      const canExcludeAttributes =
        eventName === 'SessionLifecycleEvent' &&
        Utils.isFunction(this._newrelic.setCustomAttribute);
      let attributesToRestore: Array<[string, any]> = [];

      if (canExcludeAttributes) {
        const deviceConfig = getAppConfig() || {};
        const user = store.getState().user || {};

        attributesToRestore = [
          ['HKS', storage.getItem('HKS')],
          ['user_id', user.isLoggedIn ? user.user_id : null],
          ['username', user.isLoggedIn ? user.username : null],
          ['device_category', deviceConfig.device_category],
          ['device_id', deviceConfig.device_id],
          ['device_manufacturer', deviceConfig.device_manufacturer],
          ['device_model', deviceConfig.device_model],
          ['device_type', deviceConfig.device_type],
        ];
      }

      try {
        attributesToRestore.forEach(([name]) => {
          this._newrelic.setCustomAttribute(name, null);
        });
        this._newrelic.addPageAction(eventName, information);
      } catch (error) {
        logger.error('addPageAction', error)
      } finally {
        attributesToRestore.forEach(([name, value]) => {
          try {
            this._newrelic.setCustomAttribute(
              name,
              value === null || value === undefined ? null : value
            );
          } catch (error) {
            logger.error('restoreCustomAttribute', name, error);
          }
        });
      }
    }
  }

  actionText(action: string) {
    if (AnalyticsRESTClient.isEnabled()) {

      this.recordCustomEvent(
        "BrowserInteraction",
        {actionText: action, platform: Device.getDevice().getPlatform()}
      );

      return;
    }
    if (Utils.isFunction(this._newrelic.interaction)) {
      try {

        const myInteraction = this._newrelic.interaction();
        myInteraction.actionText(action)
          .save();

      } catch (error) {
        logger.error('actionText', error)

      }
    }
  }


  setPageViewName(name: string, host: string) {

    try {
      if (Utils.isFunction(this._newrelic.setPageViewName)) {
        this._newrelic.setPageViewName(name, host)
      }
    } catch (error) {
      logger.error('setPageViewName', error)
    }
  }

  addRelease(component: string = 'AAF component', version: string = '1.0.0') {

    try {
      if (Utils.isFunction(this._newrelic.addRelease)) {

        this._newrelic.addRelease(component, version)
      }
    } catch (error) {
      logger.error('addRelease', error)
    }
  }

  addToTrace() {

    try {

      if (Utils.isFunction(this._newrelic.addToTrace)) {
        var obj = {
          // REQUIRED
          name: 'AAF Event Name GCR',
          start: 1417044274239, // Time in ms since epoch
          // OPTIONAL
          end: 1417044274252,
          // Time in ms since epoch. Defaults to same as start resulting in trace object with a duration of zero.
          origin: 'AAF Origin of event',
          // Defaults to empty string
          type: 'AAF What type of event was this'
          // Defaults to empty string
        };


        this._newrelic.addToTrace(obj)
      }
    } catch (error) {
      logger.error('addToTrace', error)
    }

  }

  addEventListener() {

  }

  setInteractionNewRelic(name: string) {
    try {
      if (Utils.isFunction(this._newrelic.interaction)) {
        this._newrelic.interaction()
          .setAttribute('AAFusername', 'GCR')
          .setAttribute('AAFuserId', '007')
          .setName(name)
          .save();
      }
    } catch (error) {
      logger.error('Interaction', error)
    }
  }


  setApplicationVersion(version: string = '1.0.0') {
    const nrInstance = AnalyticsRESTClient.getNRInstance();
    if (nrInstance) {
      nrInstance.setGlobalAttribute('appVersion', version);
      return;
    }
    if (Utils.isFunction(this._newrelic.setApplicationVersion)) {
      this._newrelic.setApplicationVersion(version);
    }
  }

  setCurrentRouteName(pathname: string) {
    const nrInstance = AnalyticsRESTClient.getNRInstance();
    if (nrInstance) {
      nrInstance.setGlobalAttribute('currentRoute', pathname);
      return;
    }
    if (Utils.isFunction(this._newrelic.setCurrentRouteName)) {
      this._newrelic.setCurrentRouteName(pathname);
    }
  }

  setErrorHandlerNewRelic() {
    logger.debug('setErrorHandlerNewRelic:::', window.newrelic.setErrorHandler !== undefined);
  }

  setUserId(userId: string = storage.getItem('user_id')) {
    AnalyticsRESTClient.setUserId(userId);
    if (!AnalyticsRESTClient.isEnabled() && Utils.isFunction(this._newrelic.setUserId)) {
      this._newrelic.setUserId(userId);
    }
  }
}



export default new NewRelic();



// WEBPACK FOOTER //
// ./src/utils/trackers/NewRelic.ts